import { render } from "./client-parent.vue?vue&type=template&id=f853a46c&scoped=true&ts=true"
import script from "./client-parent.vue?vue&type=script&lang=ts"
export * from "./client-parent.vue?vue&type=script&lang=ts"

import "./client-parent.vue?vue&type=style&index=0&id=f853a46c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f853a46c"]])

export default __exports__